import type { OperatorAttachedFile } from "@lib/agenticAi/types";

import type { BriefOperatorAttachedFile } from "./types";

export const toOperatorAttachedFile = (descriptor: BriefOperatorAttachedFile): OperatorAttachedFile => ({
  url: descriptor.url,
  fileName: descriptor.file_name,
  mimeType: descriptor.mime_type,
  context: descriptor.context,
  expiresAt: descriptor.expires_at,
  fileUpdatedAt: descriptor.file_updated_at ?? undefined,
});
